import './AlertPopup.css';
import '../JobDetailForm/JobDetailForm.css';

import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/*
  AlertPopup props:
  - show: boolean
  - onClose: () => void
  - onConfirm: () => void
  - title: string (top title)
  - type: 'alert' | 'info' (changes icon)
  - heading: string (quick tip heading)
  - body: string (quick tip body)
  - buttonText: string (primary button text)
  - showCancel?: boolean (whether to display the Cancel button; defaults to true)
*/

const typeToIcon = (type) => {
  if (type === 'alert') return '⚠️';
  return '💡';
};

const AlertPopup = ({
  show,
  onClose,
  onConfirm,
  title,
  type = 'info',
  heading,
  body,
  buttonText = 'OK',
  showCancel = true,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      centered
      dialogClassName="job-detail-form-modal-custom"
    >
      <Modal.Body className="job-detail-form-modal-body-custom">
        <div className="alert-popup alert-popup-container">
          <div className="job-modal">
            <div className="job-modal-header">
              <div className="header-left">
                <div className="job-modal-title">{title}</div>
              </div>
              <button type="button" className="close-btn" onClick={onClose} aria-label="Close">✕</button>
            </div>
            <div className="job-modal-body">
              <div className="job-main-content">
                <div className="tab-content">
                  <div className="quick-tips">
                    <div className="tips-icon">{typeToIcon(type)}</div>
                    <div className="tips-content">
                      <div className="tips-title">{heading}</div>
                      <div className="tips-text">{body}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="job-modal-footer">
              {showCancel && (
                <Button
                  variant="secondary"
                  className="btn-modern-secondary"
                  onClick={onClose}
                  type="button"
                >
                  Cancel
                </Button>
              )}
              <Button
                variant={type === 'alert' ? 'danger' : 'primary'}
                className="btn-modern-primary"
                onClick={onConfirm}
              >
                {buttonText}
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AlertPopup;
